import { render } from "./FpInput.vue?vue&type=template&id=c2351628&scoped=true"
import script from "./FpInput.vue?vue&type=script&lang=js"
export * from "./FpInput.vue?vue&type=script&lang=js"

import "./FpInput.vue?vue&type=style&index=0&id=c2351628&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2351628"]])

export default __exports__